import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from "react-redux";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './slices';
import { AppContextProvider } from 'context/AppContext';
// import { AuthProvider } from 'context/context';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const store = configureStore({ reducer: rootReducer, devTools: true });
root.render(
  <React.StrictMode>
    {/* <AuthProvider> */}
      <Provider store={store}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <AppContextProvider>
            <App />
          </AppContextProvider>
        </BrowserRouter>
      </Provider>
    {/* </AuthProvider> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
